import React, { useEffect, useState } from 'react'
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import Header from "../../layout/header";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../Images/no-data-found.webp";
import BottomMenu from "../../layout/bottomMenu";
import { useLocation } from 'react-router-dom';
import *  as Constants from '../constants';
import { Modal,  Card, Row, Col ,Button} from 'react-bootstrap';
 
import { toast } from "react-toastify";
import SuccessModal from "../../CustomModal/Success";
import ModalPop from '../../modal/modal';

const LeadList = ({
    getAllLeadsListing,
    allLeads = [],
    match,
    getLeadFilters,
    leadFilters,
    updateLeadStatus,
    updatedLead=[],
    updateLeadAccount,
    leadAccount=[],
    createNewLead,
    newLead=[],
    history
}) => {

    const [isLoading, setIsLoading] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [filterInputList, setFilterInputList] = useState([{}])
    const [open, setOpen] = useState(false);
    const [isFilterRemove, setIsRemoveFilter] = useState(false)
    const [pageNo, setPage] = useState(1)
    const [showApproveModal,setShowApproveModal]=useState(false);
    const [showHoldModal,setShowHoldModal]=useState(false);
    const [showRejectModal,setShowRejectModal]=useState(false);
    const [rejectionReasons,setRejectionReasons]=useState([]);
    const [holdReasons,setHoldReasons]=useState([]);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        lead_id:'',
        utm_source:'',
        name:'',
        contact_no:'',
        category:'',
        call_date:'',
        call_no:'',
        department_id:'',
        next_call_date:'',
        hold_remarks:'',
        rejection_remarks:'',
        other_remarks:'',
        status:'',
        next_action:'',
        account_type:''
    });
    const [userOptions, setUserOptions] = useState([]);
    const [departmentOptions,setDepartmentOptions]=useState([]);
    const [utmSources,setUtmSources]=useState([]);

    const location = useLocation();
    const newLeadSources=utmSources && utmSources.length>0 && utmSources?.find(source=>source.id=='Email');

    // Extract the status from the URL (e.g., "pending" from "/pending-leads")
    const statusFromUrl = location.pathname.split('/')[1].split('-')[0];

    const status = Object.keys(Constants?.LEAD_STATUS).find(
        (key) => Constants?.LEAD_STATUS[key].toLowerCase() === statusFromUrl.toLowerCase()
    );

    const [leadId,setLeadId]=useState(null);
    const [show, setShow] = useState(false);
    const [callLogs, setCallLogs] = useState([]);
    const [meetings, setMeetings] = useState([]);

    const [showUpdateModal, setShowUpdateModal] = useState(false);

    const [categories,setCategories]=useState([]);
    const [prefilledUtmSource,setPrefilledUtmSource]=useState();
    const [accountTypes,setAccountTypes] = useState([]);
     
    const handleClose = () => setShow(false);
    
    const handleShow = (meetings,logs) => {
        setMeetings(meetings)
        setCallLogs(logs.slice(0, 5));
        setShow(true);
    };
    useEffect(() => {
        (async () => {
            // document.body.style.zoom = "70%";
            setIsLoading(true)
            var savedStatus=await window.localStorage.getItem('lead_management_status');
            var currPage=(savedStatus!=status)?1:await window.localStorage.getItem('lead_management_page')||pageNo;
            setPage(currPage);
            const res = await getAllLeadsListing(status,filterInputList,searchValue,currPage)
            const { lead_data,rejection_reasons,hold_reasons,departments,assignees,account_types} = res;
            const res2=await getLeadFilters()
            setCategories(res2?.[0]?.values)
            setUtmSources(res2?.[1]?.values)
            setDepartmentOptions(departments);
            setUserOptions(assignees)
            setRejectionReasons(rejection_reasons??[])
            setHoldReasons(hold_reasons??[])
            setAccountTypes(account_types??[]);
            setIsLoading(false)
        })()
    }, [])

    const onPageChange = async (val) => {
        setIsLoading(true)
        setPage(val?.selected + 1)
        localStorage.setItem('lead_management_status',status)
        localStorage.setItem('lead_management_page',val?.selected + 1)
        await getAllLeadsListing(status,filterInputList,searchValue,val?.selected + 1)
        setIsLoading(false)
    };

    const handlePreviousUrl = () => {
        // localStorage.setItem('previous_url', previousPageUrl)
    }

    const handleFilter = async (key, value, stringValue = '') => {

        const list = [...filterInputList]
        list[0][key] = value
        setFilterInputList(list)
    }

    const handleSearch = async () => {
        setIsLoading(true)
        if (searchValue === '') {
            await getAllLeadsListing(status,filterInputList,'',pageNo)
        }else{
            await getAllLeadsListing(status,filterInputList,searchValue,pageNo)
        }
        setIsLoading(false)
    }

    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        await getAllLeadsListing(status,filterInputList,searchValue,pageNo)
        setIsLoading(false)
    }

    const handleRemoveFilter = async (key) => {
        if (key !== '') {
            delete filterInputList[0][key]
            setFilterInputList(filterInputList)
            setIsLoading(true)
            await getAllLeadsListing(status,filterInputList,searchValue,pageNo)
            setIsLoading(false)
        }
    }

    const renderCellContent = (text, index, key) => {
        const isExpanded = expandedRows[`${index}-${key}`];
        const displayText = isExpanded ? text : text.slice(0, 100) + (text.length > 100 ? '...' : '');
    
        return (
          <span
            onClick={() => toggleExpand(`${index}-${key}`)}
            style={{ cursor: text.length > 100 ? 'pointer' : 'default' }}
          >
            {displayText}
          </span>
        );
      };

    const [expandedRows, setExpandedRows] = useState({});

    const toggleExpand = (index) => {
        setExpandedRows((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };
    useEffect(() => {
        (async () => {
            if (isFilterRemove) {
                setFilterInputList([{}])
                setIsLoading(true)
                await getAllLeadsListing(status,[{}],searchValue,pageNo)
                setIsLoading(false)
                setIsRemoveFilter(false)
            }
        })()
    }, [isFilterRemove])

    const cellStyle = {
        whiteSpace: 'nowrap',
        overflow: 'auto',
      };
      
    useEffect(() => {
        (async () => {
            // setIsLoading(true);
            const leadFound=allLeads?.data?.find(lead=>lead.id==leadId);
            setFormData({
                lead_id:leadFound?.id,
                utm_source:leadFound?.utm_source,
                name:leadFound?.name,
                contact_no:leadFound?.contact_no,
                category:leadFound?.category,
                call_date:new Date().toISOString().split('T')[0] || '',
                call_no:parseInt(leadFound?.total_calls)+1,
                status:leadFound?.status,
                department_id:'',
                next_call_date:'',
                hold_reason:'',
                rejection_reason:'',
                other_remarks:'',
                account_type:''
            });
            // setIsLoading(false); 
        })();
    }, [leadId]);
    
        
        const handleInputChange = (e) => {
            const { name, value } = e.target;
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        };
    
        const handleApproval = async () => {
            setIsLoading(true)
            const validateForm = () => {
                if (!formData.department_id) {
                    toast.error("Department is required");
                    return false;
                }
                if (formData.department_id!=4 && !formData.account_id) {
                    toast.error("Account ID is required");
                    return false;
                }
                if (!formData.next_call_date) {
                    toast.error("Next Call Date is Required");
                    return false;
                }
                if (!formData.meeting_date) {
                    toast.error("Meeting Date is Required");
                    return false;
                }
                if (formData.department_id!=4 && !formData.assigned_user_id) {
                    toast.error("Assigned User is Required");
                    return false;
                }
                if (formData.department_id!=4 && !formData.account_type) {
                    toast.error("Type of Account is Required");
                    return false;
                }
                
                return true;
            };
            try {
                setIsLoading(true);
                if (!validateForm()) {
                    setIsLoading(false);     
                    return;
                }
                const response = await updateLeadStatus({ ...formData, next_action: Constants.LEAD_STATUS_VERIFIED });
                
                if (response.status) {
                    setShowApproveModal(false)
                    setIsSuccessModalOpen(true)
                    
                }else{
                    const message=response?.response?.message
                    if(message){
                        toast.error(response.response.message)
                    }else{
                        toast.error("Something went wrong")
                    }
                }
                setIsLoading(false);     
            } catch (error) {
                console.error("Error while approving referral:", error);
                setIsLoading(false);     
            }
        };
    
        const handleRejection = async () => {
            try {
                const validateForm = () => {
                    if (!formData.rejection_reason) {
                        toast.error("Rejection Reason is required");
                        return false;
                    }
                    if (formData?.rejection_reason!='' && 
                        (formData?.rejection_reason== Constants?.REJECTION_CITY_NOT_SERVICEABLE || 
                        formData?.rejection_reason == Constants?.REJECTION_OTHER) && 
                        formData?.other_remarks==''
                    ) {
                        toast.error("Remarks is required");
                        return false;
                    }
                    return true;
                };
    
                setIsLoading(true);
                if (!validateForm()) {
                    setIsLoading(false);     
                    return;
                }
                const response = await updateLeadStatus({ ...formData, next_action: Constants.LEAD_STATUS_REJECTED });
                
                if (response.status) {
                    setShowRejectModal(false)
                    setIsSuccessModalOpen(true)
                }else{
                    const message=response?.response?.message
                    if(message){
                        toast.error(response.response.message)
                    }else{
                        toast.error("Something went wrong")
                    }
                }
                setIsLoading(false);         
            } catch (error) {
                console.error("Error while rejecting referral:", error);
                setIsLoading(false);     
            }
        };
    
        const handleHold = async () => {
            try {
                const validateForm = () => {
                    
                    if (status!=2 && !formData?.next_call_date) {
                        toast.error("Next Call Date is Required");
                        return false;
                    }
                    if (!formData?.hold_reason) {
                        toast.error("Hold Reason is required");
                        return false;
                    }
                    if (formData?.hold_reason!='' && 
                        (formData?.hold_reason== Constants?.HOLD_CITY_NOT_SERVICEABLE || 
                        formData?.hold_reason == Constants?.HOLD_OTHER) && 
                        formData?.other_remarks==''
                    ) {
                        toast.error("Remarks is required");
                        return false;
                    }
                    return true;
                };
    
                setIsLoading(true);
                if (!validateForm()) {
                    setIsLoading(false);     
                    return;
                }
                const response = await updateLeadStatus({ ...formData, next_action: Constants.LEAD_STATUS_HOLD });
                
                if (response.status) {
                    setShowHoldModal(false)
                    setIsSuccessModalOpen(true)
                }else{
                    const message=response?.response?.message
                    if(message){
                        toast.error(response.response.message)
                    }else{
                        toast.error("Something went wrong")
                    }
                }
                setIsLoading(false);         
            } catch (error) {
                console.error("Error while rejecting referral:", error);
                setIsLoading(false);     
            }
        };
    
    function closeModal() {
        setShowApproveModal(false);
        setShowRejectModal(false);
        setShowHoldModal(false);
        setLeadId(null);
        setFormData({
            lead_id:'',
            utm_source:'',
            name:'',
            contact_no:'',
            category:'',
            call_date: '',
            call_no:'',
            status:'',
            department_id:'',
            meeting_date:'',
            next_call_date:'',
            hold_reason:'',
            rejection_reason:'',
            other_remarks:'',
            account_type:''
        });
        // window.location.reload()
    }

    function closeUpdatemodal(){
        setShowUpdateModal(false);
        setUpdateFormData({
            parkplus_lead_id:'',
            account_id:'',
            meeting_date:''
        });

        // setFormData({
        //     lead_id:'',
        //     utm_source:'',
        //     name:'',
        //     contact_no:'',
        //     category:'',
        //     call_date: '',
        //     call_no:'',
        //     status:'',
        //     department_id:'',
        //     next_call_date:'',
        //     hold_reason:'',
        //     rejection_reason:'',
        //     other_remarks:'',
        // });
        // window.location.reload();
    }
    const handleUpdate = async()=>{
        setIsLoading(true);
        const res=await updateLeadAccount(updateFormData)
        if(['No Account found for the entered ID'].includes(res.message)){
            toast.error("No Account found for the entered ID");
            setIsLoading(false)
            return;
        }
        if(res.data==true){
            setIsSuccessModalOpen(true)
        }else{
            toast.error("Something went wrong");
        }
        setUpdateFormData({
            parkplus_lead_id:'',
            account_id:'',
            meeting_date:''
        });
        setIsLoading(false)
        
    }
    const [updateFormData,setUpdateFormData]=useState({
        parkplus_lead_id:'',
        account_id:'',
        meeting_date:''
    });

    const [newLeadFormData,setNewLeadFormData]=useState({
        utm_source:'',
        category: 'Email',
        city:'',
        society_name:'',
        name: '',
        email_id:'',
        contact_no: '',
        query: ''
    });
    const [showNewModal,setShowNewModal] =useState(false);
    
    const handleChange = (e) => {
        const { id, value } = e.target;
        setNewLeadFormData(prevState => ({
            ...prevState,
            [id]: value
        }));
    };

    const closeNewModal= (e) => {
        setShowNewModal(false);
        setNewLeadFormData({
            utm_source:'',
            category: 'Email',
            city:'',
            society_name:'',
            name: '',
            email_id:'',
            contact_no: '',
            query: ''
        });
    };
    const handleSubmit = async() => {
        const validateForm = () => {
            // if (!newLeadFormData?.utm_source) {
            //     toast.error("Source is required");
            //     return false;
            // }
            // if (!newLeadFormData?.category) {
            //     toast.error("Category is required");
            //     return false;
            // }
            // if (!newLeadFormData?.city) {
            //     toast.error("City is required");
            //     return false;
            // }
            // if (!newLeadFormData?.society_name) {
            //     toast.error("Society Name is required");
            //     return false;
            // }
            // if (!newLeadFormData?.name) {
            //     toast.error("Name is required");
            //     return false;
            // }
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (newLeadFormData.email_id && !emailRegex.test(newLeadFormData.email_id)) {
                toast.error("Please enter a valid email address");
                return false;
            }

            // Phone number validation (10 digits)
            const phoneRegex = /^\d{10}$/;
            if (newLeadFormData.contact_no && !phoneRegex.test(newLeadFormData.contact_no)) {
                toast.error("Contact No. must be 10 digits");
                return false;
            }

            // if (!newLeadFormData?.query) {
            //     toast.error("Query is required");
            //     return false;
            // }

            return true;
        }

        setIsLoading(true);

        if (!validateForm()) {
            setIsLoading(false);
            return;
        }

        const res= await createNewLead(newLeadFormData);
        if(res==true){
            toast.success("Lead created Successfully")
            setShowNewModal(false)
            setIsLoading(false);
            window.location.reload()
        }else{
            toast.error("Something went wrong")
            setIsLoading(false);
        }
    };
    return (
        <>
        <Loader isLoading={isLoading} />
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={'Data updated successfully'}
                url={window.location}
            />
            
            <ModalPop
            title="Fill the following details"
            show={showUpdateModal}
            handleModalHide={closeUpdatemodal}
            keyboard
            backdrop
            className="modal-lg"
            >
            <div className="container">
                <div className="row g-3 justify-content-center align-items-center mt-3"> 

                    {/* Account ID Field */}
                    <div className="col-sm-12 col-md-6">
                        <div className="mb-3">
                            <label htmlFor="account_id" className="form-label">Account ID</label>
                            <input type="number" id="account_id" className="form-control"
                            value={updateFormData.account_id||''}
                             onChange={(e) => setUpdateFormData({ ...updateFormData, account_id: e.target.value })}  />
                        </div>
                    </div>

                    {/* Meeting Date Field */}
                    <div className="col-sm-12 col-md-6">
                        <div className="mb-3">
                            <label htmlFor="meeting_date" className="form-label">Meeting Date</label>
                            <input 
                                type="date" 
                                id="meeting_date" 
                                className="form-control" 
                                min={new Date().toISOString().split('T')[0]}
                                value={updateFormData.meeting_date? new Date(updateFormData.meeting_date).toLocaleDateString('en-CA'): ''} 
                                onChange={(e) => setUpdateFormData({ ...updateFormData, meeting_date: e.target.value })} 
                            />
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="col-12 text-center">
                        <button 
                            type="button" 
                            onClick={() => {
                                handleUpdate();
                            }}
                            className="btn btn-primary px-4" 
                        >
                            Submit
                        </button>
                    </div>

                </div>
            </div>
        </ModalPop>


            <ModalPop
                title="Fill the following details"
                show={showApproveModal}
                handleModalHide={closeModal}
                keyboard
                backdrop
                className="modal-lg"
            >
                {/* <div className="container"> */}
                    <div className="row g-3"> 
                        {/* First Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="lead_id" className="form-label">Lead ID</label>
                                <input type="number" id="lead_id" className="form-control" value={formData.lead_id} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="utm_source" className="form-label">UTM Source</label>
                                <input type="text" id="utm_source" className="form-control" value={formData.utm_source} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Name</label>
                                <input type="text" id="name" className="form-control" value={formData.name} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="contact_no" className="form-label">Contact No.</label>
                                <input type="text" id="contact_no" className="form-control" value={formData.contact_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                
                                <label htmlFor="category" className="form-label">Category</label>
                                <select
                                    className="form-control"
                                    id="category"
                                    name="category"
                                    value={formData.category}
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value="">Choose...</option>
                                    {categories?.map(category => (
                                        <option key={category.id} value={category.name}>
                                            {category.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="call_date" className="form-label">Call Date</label>
                                <input type="date" id="call_date" className="form-control" value={formData.call_date} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="account_type" className="form-label">Type of Account<span className="text-danger">*</span></label>
                                <select
                                    className="form-control"
                                    id="account_type"
                                    name="account_type"
                                    value={formData.account_type}
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value="">Choose...</option>
                                    {accountTypes?.map(type => (
                                        <option key={type.id} value={type.id}>
                                            {type.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Second Column */}
                        <div className="col-sm-12 col-md-6">
                            
                            <div className="mb-3">
                                <label htmlFor="call_no" className="form-label">Call No</label>
                                <input type="number" id="call_no" className="form-control" value={formData.call_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="department_id" className="form-label">Department<span className="text-danger">*</span></label>
                                <select
                                    id="department_id"
                                    name="department_id"
                                    className="form-control"
                                    onChange={handleInputChange}
                                    value={formData.department_id || ''}
                                >
                                    <option value="">Choose...</option>
                                    {departmentOptions.map(option => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="account_id" className="form-label">Account ID<span className="text-danger">*</span></label>
                                <input 
                                    type="text" 
                                    id="account_id" 
                                    className="form-control" 
                                    value={formData.account_id} 
                                    onChange={(e) => setFormData({ ...formData, account_id: e.target.value })} 
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="next_call_date" className="form-label">Next Call Date<span className="text-danger">*</span></label>
                                <input 
                                    type="date" 
                                    id="next_call_date" 
                                    className="form-control" 
                                    min={new Date().toISOString().split('T')[0]}
                                    value={formData.next_call_date || ''} 
                                    onChange={(e) => setFormData({ ...formData, next_call_date: e.target.value })} 
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="meeting_date" className="form-label">Meeting Date<span className="text-danger">*</span></label>
                                <input 
                                    type="date" 
                                    id="meeting_date" 
                                    className="form-control" 
                                    min={new Date().toISOString().split('T')[0]}
                                    value={formData.meeting_date || ''} 
                                    onChange={(e) => setFormData({ ...formData, meeting_date: e.target.value })} 
                                />
                            </div>
                            <div className="mb-4">
                                <label htmlFor="assignedUser" className="form-label">Assign User<span className="text-danger">*</span></label>
                                <select
                                    id="assignedUser"
                                    name="assigned_user_id"
                                    className="form-control"
                                    onChange={handleInputChange}
                                    value={formData?.assigned_user_id || ''}
                                >
                                    <option value="">Choose...</option>
                                    {userOptions.map(option => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    {/* </div> */}

                    {/* Submit Button */}
                    <div className="w-100 d-flex items-center text-center mt-3" style={
                        {display: "flex",
                        justifyContent: "center"
                        }}>
                        <button 
                            type="button" 
                            onClick={handleApproval}
                            className="btn btn-primary px-4" 
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </ModalPop>

            <ModalPop
                title='Fill the following details'
                show={showRejectModal}
                handleModalHide={closeModal}
                keyboard
                backdrop
            >
                <div className="row g-3"> 
                        {/* First Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="lead_id" className="form-label">Lead ID</label>
                                <input type="number" id="lead_id" className="form-control" value={formData.lead_id} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="utm_source" className="form-label">UTM Source</label>
                                <input type="text" id="utm_source" className="form-control" value={formData.utm_source} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Name</label>
                                <input type="text" id="name" className="form-control" value={formData.name} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="contact_no" className="form-label">Contact No.</label>
                                <input type="text" id="contact_no" className="form-control" value={formData.contact_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                
                                <label htmlFor="category" className="form-label">Category</label>
                                <select
                                    className="form-control"
                                    id="category"
                                    name="category"
                                    value={formData.category}
                                    onChange={handleChange}
                                    required
                                    disabled={true}
                                >
                                    <option value="">Choose...</option>
                                    {categories?.map(category => (
                                        <option key={category.id} value={category.name}>
                                            {category.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Second Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="call_date" className="form-label">Call Date</label>
                                <input type="date" id="call_date" className="form-control" value={formData.call_date} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="call_no" className="form-label">Call No</label>
                                <input type="number" id="call_no" className="form-control" value={formData.call_no} readOnly disabled/>
                            </div>
                            <div className="mb-4">
                                <label htmlFor="rejectionReasons" className="form-label">Rejection Reason<span className="text-danger">*</span></label>
                                <select
                                    id="rejectionReasons"
                                    name="rejection_reason"
                                    className="form-control"
                                    onChange={handleInputChange}
                                    value={formData?.rejection_reason || ''}
                                >
                                    <option value="">Choose...</option>
                                    {rejectionReasons.map(option => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            
                            {(formData.rejection_reason== Constants?.REJECTION_CITY_NOT_SERVICEABLE || formData.rejection_reason== Constants?.REJECTION_OTHER )&&
                                <div className="mb-4">
                                    <label htmlFor="other_remarks" className="form-label">Remarks<span className="text-danger">*</span></label>
                                    <textarea
                                        id="other_remarks"
                                        name="other_remarks"
                                        className="form-control"
                                        rows="3"
                                        onChange={handleInputChange}
                                    />
                                </div>
                            }
                        </div>
                    {/* </div> */}

                    {/* Submit Button */}
                    <div className="w-100 d-flex items-center text-center mt-3" style={
                        {display: "flex",
                        justifyContent: "center"
                        }}> 
                        <button 
                            type="button" 
                            onClick={handleRejection}
                            className="btn btn-primary px-4" 
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </ModalPop>
            <ModalPop
                title='Fill the following details'
                show={showHoldModal}
                handleModalHide={closeModal}
                keyboard
                backdrop
                // url={url}
            >
                <div className="row g-3"> 
                        {/* First Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="lead_id" className="form-label">Lead ID</label>
                                <input type="number" id="lead_id" className="form-control" value={formData.lead_id} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="utm_source" className="form-label">UTM Source</label>
                                <input type="text" id="utm_source" className="form-control" value={formData.utm_source} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Name</label>
                                <input type="text" id="name" className="form-control" value={formData.name} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="contact_no" className="form-label">Contact No.</label>
                                <input type="text" id="contact_no" className="form-control" value={formData.contact_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                
                                <label htmlFor="category" className="form-label">Category</label>
                                <select
                                    className="form-control"
                                    id="category"
                                    name="category"
                                    value={formData.category}
                                    onChange={handleChange}
                                    required
                                    disabled={true}
                                >
                                    <option value="">Choose...</option>
                                    {categories?.map(category => (
                                        <option key={category.id} value={category.name}>
                                            {category.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Second Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="call_date" className="form-label">Call Date</label>
                                <input type="date" id="call_date" className="form-control" value={formData.call_date} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="call_no" className="form-label">Call No</label>
                                <input type="number" id="call_no" className="form-control" value={formData.call_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="next_call_date" className="form-label">Next Call Date{status != '2' && <span className="text-danger">*</span>}</label>
                                <input 
                                    type="date" 
                                    id="next_call_date" 
                                    className="form-control" 
                                    value={formData.next_call_date || ''} 
                                    min={new Date().toISOString().split('T')[0]}
                                    onChange={(e) => setFormData({ ...formData, next_call_date: e.target.value })} 
                                />
                            </div>
                            
                            <div className="mb-4">
                                <label htmlFor="holdReasons" className="form-label">Hold Reason<span className="text-danger">*</span></label>
                                <select
                                    id="holdReasons"
                                    name="hold_reason"
                                    className="form-control"
                                    onChange={handleInputChange}
                                    value={formData?.hold_reason || ''}
                                >
                                    <option value="">Choose...</option>
                                    {holdReasons.map(option => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {(formData.hold_reason== Constants?.HOLD_CITY_NOT_SERVICEABLE || formData.hold_reason== Constants?.HOLD_OTHER )&&
                                <div className="mb-4">
                                    <label htmlFor="other_remarks" className="form-label">Remarks<span className="text-danger">*</span></label>
                                    <textarea
                                        id="other_remarks"
                                        name="other_remarks"
                                        className="form-control"
                                        rows="3"
                                        onChange={handleInputChange}
                                    />
                                </div>
                            }
                        </div>
                    {/* </div> */}

                    {/* Submit Button */}
                    <div className="col-md-12 d-flex items-center text-center mt-3" style={
                        {display: "flex",
                        justifyContent: "center"
                        }}>
                        <button 
                            type="button" 
                            onClick={handleHold}
                            className="btn btn-primary px-4" 
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </ModalPop>
            <ModalPop
                title='Fill the following details'
                show={showNewModal}
                handleModalHide={closeNewModal}
                keyboard
                backdrop
            >
                <div className="row g-3">
                    {/* First Column */}
                    <div className="col-sm-12 col-md-6">
                    <div className="mb-3">
                            <label htmlFor="category" className="form-label">Source</label>
                            <select
                                className="form-control"
                                id="utm_source"
                                name="utm_source"
                                value={newLeadFormData.utm_source}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Choose...</option>
                                {[newLeadSources]?.map(source => (
                                    <option key={source.id} value={source.name}>
                                        {source.name}
                                    </option>
                                ))}
                            </select>
                            
                        </div>
                        <div className="mb-3">
                            <label htmlFor="category" className="form-label">Category</label>
                            <select
                                className="form-control"
                                id="category"
                                name="category"
                                value={newLeadFormData.category}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Choose...</option>
                                {categories?.map(category => (
                                    <option key={category.id} value={category.name}>
                                        {category.name}
                                    </option>
                                ))}
                            </select>
                            
                        </div>
                        <div className="mb-3">
                            <label htmlFor="city" className="form-label">City</label>
                            <input
                                type="text"
                                id="city"
                                className="form-control"
                                value={newLeadFormData.city}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="society_name" className="form-label">Society Name</label>
                            <input
                                type="text"
                                id="society_name"
                                className="form-control"
                                value={newLeadFormData.society_name}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    {/* Second Column */}
                    <div className="col-sm-12 col-md-6">
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">Name</label>
                            <input
                                type="text"
                                id="name"
                                className="form-control"
                                value={newLeadFormData.name}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="email_id" className="form-label">Email ID</label>
                            <input
                                type="email"
                                id="email_id"
                                className="form-control"
                                value={newLeadFormData.email_id}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="contact_no" className="form-label">Contact No.</label>
                            <input
                                type="text"
                                id="contact_no"
                                className="form-control"
                                value={newLeadFormData.contact_no}
                                onChange={handleChange}
                                maxLength={10}
                                
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="query" className="form-label">Query</label>
                            <textarea
                                id="query"
                                className="form-control"
                                rows="5"
                                value={newLeadFormData.query}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="col-md-12 d-flex items-center text-center mt-3" style={{ display: "flex", justifyContent: "center" }}>
                        <button
                            type="button"
                            onClick={handleSubmit}
                            className="btn btn-primary px-4"
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </ModalPop>
            
            <div id="wrapper">
                <DashboardMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Lead List'}
                            history={history}
                        />
                        <div className="col-md-12 d-flex flex-column mt-20px bg-white">
                                <h1 className="h3 mb-4 text-black-100">Leads Management System</h1>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <a href="/pending-leads" style={{ textDecoration: 'none' }}>
                                            <div 
                                                className={`card border-0 ${status == Constants.LEAD_STATUS_PENDING ? "bg-info text-white" : "bg-primary text-white"}`}
                                                style={{ width: '100%', height: '60px' }}>
                                                <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                    <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>Pending Action</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <a href="/hold-leads" style={{ textDecoration: 'none' }}>
                                            <div 
                                                className={`card border-0 ${status == Constants.LEAD_STATUS_HOLD ? "bg-info text-white" : "bg-primary text-white"}`}
                                                style={{ width: '100%', height: '60px' }}>
                                                <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                    <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>On Hold</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <a href="/verified-leads" style={{ textDecoration: 'none' }}>
                                            <div 
                                                className={`card border-0 ${status == Constants.LEAD_STATUS_VERIFIED ? "bg-info text-white" : "bg-primary text-white"}`}
                                                style={{ width: '100%', height: '60px' }}>
                                                <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                    <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>Verified</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <a href="/rejected-leads" style={{ textDecoration: 'none' }}>
                                            <div 
                                                className={`card border-0 ${status == Constants.LEAD_STATUS_REJECTED ? "bg-info text-white" : "bg-primary text-white"}`}
                                                style={{ width: '100%', height: '60px' }}>
                                                <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                    <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>Rejected</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>

                            </div>
                        <div className="container-fluid common-bg">
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="d-sm-flex align-items-center justify-content-between ">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px ">
                                            <form className="form-inline mr-auto w-90 navbar-search">
                                                <div className="d-flex w-100">
                                                    <input type="text"
                                                        className="form-control bg-light border-0 small list-filter"
                                                        placeholder="Search Lead..." aria-label="Search"
                                                        aria-describedby="basic-addon2"
                                                        onChange={(e) => {
                                                            setSearchValue(e.target.value)
                                                        }}
                                                    />
                                                    <div className="btn-search">
                                                        <button className="btn btn-primary lh-32 border-left-tr-tb"
                                                            type="button"
                                                            onClick={(e) => handleSearch()}
                                                        >
                                                            <i className="fas fa-search fa-sm"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="col-md-6 cs-pos">
                                            <div className='d-flex' style={{
                                                justifyContent: 'right',
                                                paddingRight: '35px'}}                                   
                                                >
                                                <button onClick={() => setShowNewModal(!showNewModal)}
                                                    className="btn btn-sm btn-primary mr-1 btn-plus"
                                                    type="button">CREATE NEW LEAD<i
                                                        className="fa fa-plus lh-35 pd-3"></i>
                                                </button>

                                                <button onClick={() => setOpen(!open)}
                                                    className="btn btn-sm btn-primary mr-1 btn-filter"
                                                    type="button"><i
                                                        className="fa fa-filter lh-35 pd-3"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {filterInputList[0] !== undefined && Object.keys(filterInputList[0]).length > 0 &&
                                    <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                        <div className="row pd-filter-div">
                                            <div className="col-md-12 col-sm-12 d-flex">
                                                <div className="applied-filter">
                                                    {Object.keys(filterInputList[0]).map((val, i) => {
                                                        return (
                                                            <>
                                                                <span className="fd-1">
                                                                    <span style={{ textTransform: "capitalize" }}>
                                                                        {val.replaceAll("_", " ")}
                                                                    </span>
                                                                    {" - " + filterInputList[0][val]}
                                                                    <i className="bi bi-x-circle" onClick={(e) => { handleRemoveFilter(val) }}></i></span>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                <Modal show={show} onHide={handleClose} size="lg">
                                <Modal.Dialog style={{ maxWidth: '125%', width: '125%' }}> 
                                    <Modal.Header closeButton>
                                        <Modal.Title>Call Log Details</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                    <h5>Meetings</h5>
                                    <Row className="g-4">
                                        {meetings!=undefined && meetings.length>0 && meetings.map((meeting, index) => (
                                            <Col key={index} md={4}>
                                                <Card className="h-100 shadow-sm">
                                                    <Card.Body>
                                                        <Card.Title>{meeting.name}</Card.Title>
                                                        <Card.Subtitle className="mb-2 text-muted">Assigned to: {meeting.assign_to}</Card.Subtitle>
                                                        <Card.Text>
                                                            <strong>Meeting Date:</strong> {meeting.closure_date ? new Date(meeting.closure_date).toISOString().split('T')[0] : 'N/A'} <br />
                                                            <strong>Module Type:</strong> {meeting.module_type} <br />
                                                            <strong>MOM:</strong>
                                                            <textarea 
                                                                className="form-control" 
                                                                value={meeting.mom || ''} 
                                                                rows="3" 
                                                                readOnly 
                                                                style={{ resize: "none", overflowY: "auto", height: "100px" }}
                                                            />                                                        
                                                        </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                    <h5 className="mt-4">Call Logs</h5>
                                    {callLogs && callLogs.length > 0 && callLogs.map((log, index) => (
                                        <table 
                                            key={index} 
                                            style={{
                                                width: "100%",
                                                borderCollapse: "collapse",
                                                marginBottom: "20px",
                                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                                borderRadius: "8px",
                                                overflow: "hidden"
                                            }}
                                        >
                                            <tbody>
                                                {[
                                                    { label: "Call No", value: log.call_no },
                                                    { label: "Call Date", value: new Date(log.call_date).toLocaleString() },
                                                    { label: "Hold Reason", value: log.hold_reason || "N/A" },
                                                    { label: "Rejection Reason", value: log.rejection_reason || "N/A" },
                                                    { label: "Other Remarks", value: log.other_remarks || "N/A" },
                                                    { label: "Next Action", value: log.next_action },
                                                    { label: "Next Call Date", value: log.next_call_date ? new Date(log.next_call_date).toLocaleDateString():'N/A' },
                                                    { label: "Meeting Date", value: log.meeting_date ? new Date(log.meeting_date).toLocaleDateString() : 'N/A' }
                                                ].map((row, i) => (
                                                    <tr 
                                                        key={i} 
                                                        style={{
                                                            background: i % 2 === 0 ? "#f9f9f9" : "#ffffff",
                                                            borderBottom: "1px solid #ddd",
                                                            padding: "10px"
                                                        }}
                                                    >
                                                        <th 
                                                            style={{
                                                                textAlign: "left",
                                                                padding: "12px",
                                                                fontWeight: "600",
                                                                background: "#e0e0e0",
                                                                color: "#333",
                                                                width: "35%",
                                                            }}
                                                        >
                                                            {row.label}
                                                        </th>
                                                        <td 
                                                            style={{
                                                                textAlign: "left",
                                                                padding: "12px",
                                                                color: "#555",
                                                                fontWeight: "500"
                                                            }}
                                                        >
                                                            {row.value}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    ))}

                                    </Modal.Body>
                                    </Modal.Dialog>
                                </Modal>

                                <div className="row">
                                {allLeads?.data?.length > 0 && (
                                    <div className="table-responsive mt-5" style={{ overflowX: 'auto' }}>
                                        <table className="table table-bordered table-striped">
                                        <thead style={{ backgroundColor: '#473381', color: '#ffffff' }}>
                                            <tr>
                                            {/* Pending */}
                                            <th style={{ minWidth: '70px',textAlign: 'center' }}>Lead ID</th>
                                            <th style={{ minWidth: '120px',textAlign: 'center' }}>Created At</th>
                                            {/* {status!=2 && */}
                                                <th style={{ minWidth: '250px',textAlign: 'center' }}>Actions</th>
                                            {/* } */}
                                            <th style={{ minWidth: '70px',textAlign: 'center' }}>Status</th>
                                            <th style={{ minWidth: '180px',textAlign: 'center' }}>Society Name</th>
                                            <th style={{ minWidth: '150px',textAlign: 'center' }}>City</th>
                                            {status==2 && (
                                                <>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>Contract Status</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>LeadX Gates</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>Fusion Onboarded Gates</th>
                                                </>
                                            )}
                                            {/* All Except Pending */}
                                            {['2','3','4'].includes(status) && (
                                                <>
                                                <th style={{ minWidth: '80px',textAlign: 'center'}}>No. of Calls</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>Call Logs</th>
                                                </>
                                            )}
                                            <th style={{ minWidth: '120px' ,textAlign: 'center'}}>UTM Source</th>
                                            <th style={{ minWidth: '150px' ,textAlign: 'center'}}>Category</th>
                                            <th style={{ minWidth: '180px' ,textAlign: 'center'}}>Name</th>
                                            <th style={{ minWidth: '200px' ,textAlign: 'center'}}>Email ID</th>
                                            <th style={{ minWidth: '180px' ,textAlign: 'center'}}>Contact Number</th>
                                            <th style={{ minWidth: '450px',textAlign: 'center'}}>Query</th>
                                            {/* Rejected */}
                                            {status==3 && (
                                                <>
                                                <th style={{ minWidth: '70px',textAlign: 'center'}}>Rejected Date</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>Rejection By</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>Rejection Reason</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>Rejection Remarks</th>
                                                </>
                                            )}
                                            
                                            {/* Approved */}
                                            {status==2 && (
                                                <>
                                                <th style={{ minWidth: '70px',textAlign: 'center'}}>Meeting Date</th>
                                                <th style={{ minWidth: '70px',textAlign: 'center'}}>Verified Date</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>Verified By</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>Account ID</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>Account Assigned To</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>Type of Account</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>LeadX Status</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>Site Status</th>
                                                </>
                                            )}
                                            
                                            {/* Hold */}
                                            {status==4 && (
                                                <>
                                                <th style={{ minWidth: '70px',textAlign: 'center'}}>Last Action Date</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>Last Action By</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>Hold Reason</th>
                                                <th style={{ minWidth: '100px',textAlign: 'center'}}>Hold Remarks</th>
                                                </>
                                            )}
                                            
                                            
                                            {status=='2' && 
                                                <th style={{ minWidth: '70px',textAlign: 'center'}}>Edit Meeting Data</th>
                                            }
                                            
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {allLeads.data.map((lead, index) => (
                                            <tr key={index} >
                                                <td style={{ minWidth: '70px' }}>{lead.id}</td>
                                                <td style={{ ...cellStyle,minWidth: '120px' }}>
                                                {lead?.created_at ? new Date(lead.created_at).toISOString().split('T')[0] : 'N/A'}
                                                </td>
                                                
                                                <td style={{ minWidth: '250px' }}>
                                                <span>
                                                    {(lead.status==1|| lead.status==4) && (
                                                        <>
                                                        <button className="btn btn-success btn-sm mr-2" style={{ width: '80px', marginBlock: '5px' }}
                                                            onClick={()=>{
                                                                setLeadId(lead.id)
                                                                // setIsLoading(true)
                                                                setShowApproveModal(true)
                                                                // setIsLoading(false)
                                                            }}
                                                        >
                                                            Approve
                                                        </button>
                                                        <button className="btn btn-danger btn-sm mr-2" style={{ width: '80px', marginBlock: '5px' }}
                                                        onClick={()=>{
                                                            setLeadId(lead.id)
                                                            // setIsLoading(true)
                                                            setShowRejectModal(true)
                                                            // setIsLoading(false)
                                                        }}
                                                        >
                                                            Reject
                                                        </button>
                                                        <button className="btn btn-info btn-sm mr-2" style={{ width: '80px', marginBlock: '5px' }}
                                                        onClick={()=>{
                                                            setLeadId(lead.id)
                                                            // setIsLoading(true)
                                                            setShowHoldModal(true)
                                                            // setIsLoading(false)
                                                        }}
                                                        >
                                                            Hold
                                                        </button>
                                                        </>
                                                    )}
                                                    {(lead.status==3 ) && (
                                                        <>
                                                        <button className="btn btn-success btn-sm mr-2" style={{ width: '80px', marginBlock: '5px' }}
                                                            onClick={()=>{
                                                                setLeadId(lead.id)
                                                                // setIsLoading(true)
                                                                setShowApproveModal(true)
                                                                // setIsLoading(false)
                                                            }}
                                                        >
                                                            Approve
                                                        </button>
                                                        
                                                        <button className="btn btn-info btn-sm mr-2" style={{ width: '80px', marginBlock: '5px' }}
                                                        onClick={()=>{
                                                            setLeadId(lead.id)
                                                            // setIsLoading(true)
                                                            setShowHoldModal(true)
                                                            // setIsLoading(false)
                                                        }}
                                                        >
                                                            Hold
                                                        </button>
                                                        </>
                                                    )}
                                                    {(lead.status==2) && (
                                                        <>
                                                        <button className="btn btn-primary btn-sm mr-2" style={{ width: '80px', marginBlock: '5px' }}
                                                        onClick={()=>{
                                                            setLeadId(lead.id)
                                                            // setIsLoading(true)
                                                            setShowHoldModal(true)
                                                            // setIsLoading(false)
                                                        }}
                                                        >
                                                            Log Call
                                                        </button>
                                                        </>
                                                    )}
                                                </span>
                                                </td>
                                                
                                                <td style={{ minWidth: '70px' }}>
                                                <span className={`badge bg-${lead?.status_colour_class} text-white`}>
                                                    {lead?.status_text}
                                                </span>
                                                </td>
                                                <td style={{ ...cellStyle,minWidth: '180px' }}>{renderCellContent(lead?.society_name || 'N/A', index, 'society_name')}</td>
                                                <td style={{ ...cellStyle,minWidth: '150px' }}>{renderCellContent(lead?.city || 'N/A', index, 'city')}</td>
                                                {
                                                    status==2 &&(
                                                        <>
                                                            <td style={{ ...cellStyle,minWidth: '180px' }}>{renderCellContent(lead?.contract_status || 'N/A', index, 'contract_status')}</td>
                                                            <td style={{ ...cellStyle,minWidth: '180px' }}>{lead?.leadx_gates_count || '0'}</td>
                                                            <td style={{ ...cellStyle,minWidth: '180px' }}>{lead?.fusion_gates_count || '0'}</td>
                                                        </>
                                                    )
                                                }
                                                {['2','3','4'].includes(status) && (
                                                <>
                                                <td style={{ minWidth: '80px' }}>{lead?.total_calls || 'N/A'}</td>
                                                <td style={{ minWidth: '100px'}}>
                                                    <span>
                                                        <button className="btn btn-primary btn-sm mr-2" style={{ width: '80px', marginBlock: '5px' }} 
                                                            onClick={()=>handleShow(lead?.activities,lead?.call_logs)}
                                                        >View
                                                         
                                                        </button>
                                                    </span>
                                                </td>
                                                </>
                                                )}
                                                <td style={{ ...cellStyle,minWidth: '120px' }}>{renderCellContent(lead?.utm_source || 'N/A', index, 'utm_source')}</td>
                                                
                                                <td style={{ minWidth: '150px' }}>{renderCellContent(lead?.category || 'N/A', index, 'category')}</td>
                                                <td style={{ ...cellStyle,minWidth: '180px' }}>{renderCellContent(lead?.name || 'N/A', index, 'name')}</td>
                                                <td style={{ ...cellStyle,minWidth: '200px' }}>{renderCellContent(lead?.email_id || 'N/A', index, 'email_id')}</td>
                                                <td style={{ ...cellStyle,minWidth: '180px' }}>{renderCellContent(lead?.contact_no || 'N/A', index, 'contact_no')}</td>
                                                <td style={{ minWidth: '450px',wordWrap: 'break-word', whiteSpace: 'normal' }}>{renderCellContent(lead?.query || 'N/A', index, 'query')}</td>
                                                {
                                                    status==2 &&(
                                                        <>
                                                        <td style={{ ...cellStyle,minWidth: '70px' }}>
                                                        {lead?.meeting_date ? new Date(lead.meeting_date).toLocaleDateString('en-CA') : 'N/A'}
                                                        </td>
                                                        <td style={{ ...cellStyle,minWidth: '70px' }}>
                                                        {lead?.last_call_date ? new Date(lead.last_call_date).toISOString().split('T')[0] : 'N/A'}
                                                        </td>
                                                        
                                                        <td style={{ minWidth: '150px' }}>{renderCellContent(lead?.last_call_by || 'N/A', index, 'last_call_by')}</td>
                                                        <td style={{ minWidth: '70px' }}>{lead?.account_id || 'N/A'}</td>
                                                        <td style={{ minWidth: '150px' }}>{lead?.assigned_user|| 'N/A'}</td>
                                                        <td style={{ minWidth: '150px' }}>{lead?.account_type|| 'N/A'}</td>
                                                        <td style={{ minWidth: '50px' }}>{lead?.latest_activity_name|| 'N/A'}</td>
                                                        <td style={{ minWidth: '50px' }}>{lead?.site_status|| 'N/A'}</td>
                                                        </>
                                                    )
                                                }
                                                
                                                {
                                                    ['3','4'].includes(status) &&(
                                                        <>
                                                        <td style={{ ...cellStyle,minWidth: '70px' }}>
                                                        {lead?.last_call_date ? new Date(lead.last_call_date).toISOString().split('T')[0] : 'N/A'}
                                                        </td>
                                                        <td style={{ minWidth: '150px' }}>{renderCellContent(lead?.last_call_by || 'N/A', index, 'last_call_by')}</td>
                                                        <td style={{ minWidth: '150px' }}>{renderCellContent(lead?.rejection_reason || lead?.hold_reason || 'N/A', index, 'rejection_reason')}</td>
                                                        <td style={{ ...cellStyle,minWidth: '180px' }}>{renderCellContent(lead?.other_remarks || 'N/A', index, 'other_remarks')}</td>
                                                        </>
                                                    )
                                                }
                                                
                                            
                                                {status=='2' && 
                                                <td style={{ minWidth: '150px' }}>
                                                    <span>
                                                        <button className="btn btn-primary btn-sm mr-2" style={{ width: '80px', marginBlock: '5px' }} 
                                                            onClick={()=>{
                                                                setUpdateFormData({
                                                                    parkplus_lead_id: lead?.id,
                                                                    account_id: lead?.account_id,
                                                                    meeting_date: lead?.meeting_date
                                                                })
                                                                setShowUpdateModal(true)
                                                            }}
                                                        >
                                                         Update
                                                        </button>
                                                    </span>
                                                </td>
                                                    
                                                }
                                                
                                            </tr>
                                            ))}
                                        </tbody>
                                        </table>
                                    </div>
                                )}

                                {allLeads && allLeads?.data !== undefined && allLeads?.data.length > 0 && (
                                    <div className="panel-pagination-col panel-table-pagination">
                                    <ReactPaginate
                                        previousLabel={'<'}
                                        nextLabel={'>'}
                                        breakLabel={'...'}
                                        breakClassName={'break-me'}
                                        pageCount={allLeads?.total / allLeads?.per_page}
                                        forcePage={allLeads?.current_page - 1}
                                        pageRangeDisplayed={4}
                                        onPageChange={onPageChange}
                                        activeClassName={'active'}
                                    />
                                    </div>
                                )}
                                {allLeads && allLeads?.data !== undefined && allLeads?.data.length === 0 && (
                                    <>
                                    <img src={NotFoundData} className="not-found-data" alt={''} />
                                    <div className="text-center" style={{ width: '100%' }}>
                                        Data Not Found
                                    </div>
                                    </>
                                )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu
                    smallSize={true}
                    open={open}
                    setOpen={setOpen}
                    handleSubmitFilter={handleSubmitFilter}
                    filterContent={leadFilters}
                    handleFilter={handleFilter}
                    setIsRemoveFilter={setIsRemoveFilter}
                />
            </div>

        </>
    )
}

export default LeadList